import { GlobalController } from 'src/shared/global/GlobalController'
import Person from './Person'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'person',
    component: Person,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
